import { Routes } from '@angular/router';
import { LicensesComponent } from './licenses/licenses.component';
import { resolveUserGroups } from 'customer-portal/resolvers';

export const routes: Routes = [
  {
    path: '',
    component: LicensesComponent,
    resolve: {
      'user-group': resolveUserGroups,
    },
  },
];
